import Http from "../http";

class TripServices{
    // static async getTripDetails(){
    //     return Http.get('/tripdetails');
    // }
    static async getTripDetails(serviceType){

        return Http.get(`/tripdetails?serviceType=${serviceType}`);
    }
    // static async getTripBid(){
    //     return Http.get('/tripsBid');
    // }
    static async getTripBid(serviceType){
        return Http.get(`/tripsBid?serviceType=${serviceType}`);
    }
    static async getTrip(id){
        return Http.get(`/trips/${id}`)
    }
    static async getTripswithRiders(serviceType){
        return Http.get(`/tripwithrider?serviceType=${serviceType}`);

    }
    static async getTripBids(startDate,endDate){
        return Http.get(`/tripsBid?startDate=${startDate}&endDate=${endDate}`);

    }
    static async deleteTripData(id){
        return Http.delete(`/trip/:${id}`)
    }
    

}
export default TripServices